module.exports = __webpack_public_path__ + "static/img/Clare-Polkinghorne.cdd9f94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Clare-Polkinghorne.jpg
// module id = f2Kw
// module chunks = 0